import { render, staticRenderFns } from "./mainStage.vue?vue&type=template&id=44dbeab2&scoped=true&"
import script from "./mainStage.vue?vue&type=script&lang=js&"
export * from "./mainStage.vue?vue&type=script&lang=js&"
import style0 from "./mainStage.vue?vue&type=style&index=0&id=44dbeab2&scoped=true&lang=css&"
import style1 from "./mainStage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dbeab2",
  null
  
)

export default component.exports